import React from 'react';
import { Container, Paper, Grid } from '@mui/material';
import { Navigate } from 'react-router-dom';
import DisputesTable from '@/components/disputes-table/disputes-table';
import { getToken } from '@/lib/common';

function Disputes() {
  if (!getToken()) {
    return <Navigate to="/" replace />;
  }
  return (
    <Container maxWidth={false} disableGutters sx={{ p: 0 }}>
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid item style={{ width: '100%' }}>
          <Paper
            elevation={0}
            sx={{ width: '100%', border: '1px solid #E7ECF3', boxShadow: '0 1px 2px rgba(16,35,58,.04)' }}>
            <DisputesTable />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
export default Disputes;
